import React from "react";

export const Moon = () => {
  return (
    <div>
      <div
        id={"earthsmoon"}
        style={{
          frameborder: "0",
          width: "100%",
          height: "470px",
        }}
      ></div>
    </div>
  );
};

